import React from "react";
import useClickedOutside from "../../../hooks/useClickedOutside";
import { getOS } from "../../../Utils";
import { Container } from "./styles";

export default ({ setShowHelp }) => {
  const ref = useClickedOutside(() => {
    setShowHelp(false);
  });

  const metaKey = getOS() === "windows" ? "CTRL" : "⌘";

  return (
    <Container ref={ref}>
      <a className="close" onClick={e => setShowHelp(false)}>close</a>

      <p>Canvas is currently in beta. Use it to explore ideas and collaborate spatially with the Sudowrite AI. Canvas currently works best on desktop Chrome.</p>

      <h2>Keyboard Shortcuts</h2>

      <dl>
        <section>
          <dt>
            <span>{metaKey} A</span>
          </dt>
          <dd>Select all</dd>
        </section>

        <section>
          <dt>
            <span>Del</span>
          </dt>
          <dd>Deletes a card</dd>
        </section>

        <section>
          <dt>
            <span>Space + Click + Drag</span>
          </dt>
          <dd>Pan the canvas</dd>
        </section>

        <section>
          <dt>
            <span> {metaKey} Z</span>
          </dt>
          <dd>Undo</dd>
        </section>

        <section>
          <dt>
            <span> {metaKey} + SHIFT + Z</span>
          </dt>
          <dd>Redo</dd>
        </section>

        <section>
          <dt>
            <span> {metaKey} +</span>
          </dt>
          <dd>Zoom in</dd>
        </section>

        <section>
          <dt>
            <span> {metaKey} -</span>
          </dt>
          <dd>Zoom out</dd>
        </section>

        <section>
          <dt>
            <span> {metaKey} \</span>
          </dt>
          <dd>Reset to center</dd>
        </section>

        <section>
          <dt>
            <span>{metaKey} 0</span>
          </dt>
          <dd>Reset zoom</dd>
        </section>
      </dl>
    </Container>
  );
};
